const normalizeString = string => {
  if (string)
    return string
      .toLowerCase()
      .replace(/[ãâáà]/g, 'a')
      .replace(/[éèê]/g, 'e')
      .replace(/[íì]/g, 'i')
      .replace(/[óòôõ]/g, 'o')
      .replace(/[úùû]/g, 'u')
  return null
}

export default normalizeString
